export default __webpack_public_path__ + "static/media/simrunChopra4.c1d6e089.jpg";